import React from 'react';
import {
  Box,
  Container,
  VStack,
  Heading,
  Text,
  Button,
  Icon,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const VerifyEmailSuccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box minH="80vh" bg="white" display="flex" alignItems="center" py={12}>
      <Container maxW="500px">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4 }}
        >
          <Box
            bg="white"
            border="1px solid"
            borderColor="green.200"
            borderRadius="16px"
            p={8}
            boxShadow="0 4px 20px rgba(0, 0, 0, 0.06)"
            textAlign="center"
          >
            <VStack spacing={6}>
              {/* Checkmark Icon Circle */}
              <Box
                w="80px"
                h="80px"
                borderRadius="full"
                bg="green.50"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Icon
                  viewBox="0 0 24 24"
                  boxSize="44px"
                  color="green.500"
                >
                  <path
                    fill="currentColor"
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                  />
                </Icon>
              </Box>

              <VStack spacing={3}>
                <Heading size="lg" color="neutral.900" fontWeight="700">
                  Verification Complete!
                </Heading>
                <Text color="neutral.600" fontSize="15px" lineHeight="1.6">
                  Your email has been successfully verified. Your account is now active and ready to use.
                </Text>
              </VStack>

              <Button
                colorScheme="green"
                w="full"
                h="46px"
                fontSize="15px"
                fontWeight="600"
                borderRadius="8px"
                onClick={() => navigate('/login')}
                _hover={{
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 12px rgba(46, 125, 50, 0.3)',
                }}
              >
                Click Here to Login
              </Button>
            </VStack>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default VerifyEmailSuccess;
